"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvironment = void 0;
const signals_1 = require("@wix/services-definitions/core-services/signals");
const environment_1 = require("./environment");
const createEnvironment = (config, getService) => {
    const env = (0, environment_1.createEnvironment)(config);
    const { signal } = getService(signals_1.SignalsServiceDefinition);
    const languageDirectionSignal = signal(config.languageDirection || 'ltr');
    return {
        ...env,
        getLanguageDirection: () => languageDirectionSignal.get(),
        setLanguageDirection: (direction) => languageDirectionSignal.set(direction),
    };
};
exports.createEnvironment = createEnvironment;
//# sourceMappingURL=editorEnvironment.js.map